import React, { useEffect, useState } from "react";
import "./LogsPage.scss";
import Plot from "react-plotly.js";

interface Props {
    user: string[];
    period: number[];
}

export default function ActivityPeriodPlot(props: Props) {
    var data = [{
        x: props.user,
        y: props.period,
        type: 'bar',
        transforms: [{type: 'sort', target: 'y', order: 'descending'}]
    }];
    var layout = {
        title: {
            text: 'Total Activity Period',
            font: {
                size: 20
            }
        },
        xaxis: {
            title: 'User'
        },
        yaxis: { 
            title: 'Total Activity Period (Hours)' 
        },
        margin: { l: 50, r: 50, t: 50, b: 150 }
    };

    return (
        <div className="chart-container pie-chart">
            <Plot data={data as any} layout={layout as any} useResizeHandler={true} style={{ width: '100%', height: '100%' }}/>
        </div>
    )
}
